var _path, _path2;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Sun = function Sun(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M13 3a1 1 0 1 0-2 0v1a1 1 0 1 0 2 0V3ZM6.307 4.893a1 1 0 0 0-1.414 1.414l.7.7a1 1 0 0 0 1.414-1.414l-.7-.7ZM19.107 6.307a1 1 0 0 0-1.414-1.414l-.7.7a1 1 0 0 0 1.414 1.414l.7-.7ZM3 11a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2H3ZM20 11a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2h-1ZM7.007 18.407a1 1 0 1 0-1.414-1.414l-.7.7a1 1 0 1 0 1.414 1.414l.7-.7ZM18.407 16.993a1 1 0 0 0-1.414 1.414l.7.7a1 1 0 0 0 1.414-1.414l-.7-.7ZM13 20a1 1 0 1 0-2 0v1a1 1 0 1 0 2 0v-1Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm-3 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default Sun;